export interface AlmePoweredByLinkConfig {
    poweredByLink: {
        isEnabled: boolean;
        url: string;
    };
}

/**
 * This is the baseline powered by link config.
 * @summary
 * ! Important do not edit this config with client customizations!
 * Custom client config changes should be made in src/personas/config/appConfigMain
 * @see appConfigMain
*/
const defaultConfig: AlmePoweredByLinkConfig = {
    poweredByLink: {
        isEnabled: false,
        url: 'https://www.verint.com/engagement/our-offerings/solutions/intelligent-self-service/virtual-assistant/',
    },
};

export default defaultConfig;